import homeView from './index'
import searchView from './search'

import model from './services/model'

export default {
  path: 'other',
  component: homeView,
  name: 'Private/Other',
  redirect: { name: 'Private/Other/Search' },
  children: [
    {
      path: 'search',
      component: searchView,
      name: 'Private/Other/Search'
    }
  ],
  beforeEnter (to, from, next) {
    if (!model.initDataLoaded) model.init().then(res => next())
    else next()
  }
}
